import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.625 16.25a.627.627 0 0 0-.625.625v.625c0 .69-.56 1.25-1.25 1.25H2.5c-.69 0-1.25-.56-1.25-1.25v-10c0-.69.56-1.25 1.25-1.25h4.375a.627.627 0 0 0 .625-.625A.627.627 0 0 0 6.875 5H2.5A2.5 2.5 0 0 0 0 7.5v10C0 18.879 1.12 20 2.5 20h6.25a2.5 2.5 0 0 0 2.5-2.5v-.625a.627.627 0 0 0-.625-.625m9.008-12.866L16.616.366A1.25 1.25 0 0 0 15.73 0h-4.48c-1.38 0-2.5 1.12-2.5 2.5v10a2.5 2.5 0 0 0 2.5 2.5h6.25a2.5 2.5 0 0 0 2.5-2.5V4.27c0-.332-.133-.652-.368-.886M16.25 1.768l1.98 1.982h-1.98zm2.5 10.732c0 .69-.56 1.25-1.25 1.25h-6.25c-.69 0-1.25-.56-1.25-1.25v-10c0-.69.56-1.25 1.25-1.25H15v2.5c0 .69.56 1.25 1.25 1.25h2.5z"
    }, null, -1)
  ])))
}
export default { render: render }